import React, { FC } from 'react'
import { Parcel } from '@typings/entities/Parcel'
import { columnsDefinitions } from './columnsDefinitions'
import CommonGrid from '@components/blocks/CommonGrid'
import { x } from '@xstyled/styled-components'
import usePageGridLoading from '@utils/containers/usePageGridLoading'
import * as parcelsGridStore from '@store/parcelsGrid'
import { useSelector } from 'react-redux'
import { selectors as organisationSelectors } from '@store/organisation'
import { Trans } from '@lingui/react'

type Props = {
  expeditionId?: string
}

export const actionColumnDefinition = {
  flexBasis: 40,
  addRowNumbers: true,
}

export const Parcels: FC<Props> = ({ expeditionId }) => {
  const activeOrganisation = useSelector(organisationSelectors.organisationDetail)
  const isParcelInfoAvailable = activeOrganisation?.isParcelInfoAvailable

  const { data, gridIsLoading, error, allRowsCount, gridActions, gridSelectors } = usePageGridLoading<Parcel>({
    gridName: 'expeditionParcels',
    storeModule: parcelsGridStore,
    skip: !expeditionId || !isParcelInfoAvailable,
    containerFilters: { expedition: { eq: expeditionId } },
  })

  if (!isParcelInfoAvailable) {
    return <Trans id="parcelsInfoNotAvailable" message="Parcels information is not available for this organisation" />
  }

  return (
    <x.div mb="32px" h="610px">
      <CommonGrid
        gridName="expeditionParcels"
        rowsData={data}
        actionColumnDefinition={actionColumnDefinition}
        columnsDefinitions={columnsDefinitions()}
        gridActions={gridActions}
        gridSelectors={gridSelectors}
        totalRowsCount={allRowsCount}
        withPresets={false}
        errorMessage={error}
        isLoading={gridIsLoading}
      />
    </x.div>
  )
}
